import React from 'react';
import './StatusDot.scss';

const StatusDot = ({ color }) => {
    return <span className={`status_dot status_dot--${color}`} />;
};

export default StatusDot;
